import NavLink from '../nav-link';
import languagesObj from '../../localization/languages.json';
import React, { PropTypes } from 'react';
import { Divider } from 'material-ui';
const languageSettings = languagesObj['en-US'];

const leftNav = props => (
  <div className={props.className}>
    <div className="integration-left-nav-inner">
      <div className="integration-left-nav-heading">Tourplan Integration</div>
        <div className="connections-widget">
          <NavLink
            {...props}
            classes={"nav-link connections-widget-link"}
            routeName={"/integration/authentication"}
            activeRoutes={['/integration/authentication']}
          >
            {languageSettings.integration.routeNames.authentication}
          </NavLink>
          <NavLink
            {...props}
            classes={"nav-link connections-widget-link"}
            routeName={"/integration/contracts"}
            activeRoutes={['/integration/contracts']}
          >
            {languageSettings.integration.routeNames.contracts}
          </NavLink>
          <div className="integration-left-nav-heading" style={{ fontSize: '12px' }}>Export Settings</div>
          <NavLink
            {...props}
            classes={"nav-link connections-widget-link"}
            routeName={"/integration/settings/rate-name-text"}
            activeRoutes={['/integration/settings/rate-name-text']}
          >
            Rate Name & Rate Text
          </NavLink>
          <NavLink
            {...props}
            classes={"nav-link connections-widget-link"}
            routeName={"/integration/settings/extras"}
            activeRoutes={['/integration/settings/extras']}
          >
            Extras
          </NavLink>
          <NavLink
            {...props}
            classes={"nav-link connections-widget-link"}
            routeName={"/integration/settings/cancel-hours"}
            activeRoutes={['/integration/settings/cancel-hours']}
          >
            Cancellation Hours
          </NavLink>
          <NavLink
            {...props}
            classes={"nav-link connections-widget-link"}
            routeName={"/integration/settings/tax"}
            activeRoutes={['/integration/settings/tax']}
          >
            Tax
          </NavLink>
          <NavLink
            {...props}
            classes={"nav-link connections-widget-link"}
            routeName={"/integration/settings/pricecodes"}
            activeRoutes={['/integration/settings/pricecodes']}
          >
            Price Codes
          </NavLink>
          <NavLink
            {...props}
            classes={"nav-link connections-widget-link"}
            routeName={"/integration/settings/notes"}
            activeRoutes={['/integration/settings/notes']}
          >
            Notes
          </NavLink>
        </div>
    </div>
  </div>
);

leftNav.propTypes = {
  className: PropTypes.string,
};

export default leftNav;



// WEBPACK FOOTER //
// ./src/app/components/integration/integration-left-nav.jsx